
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

interface FeatureImportanceProps {
  featureImportance: any;
}

export const FeatureImportanceChart: React.FC<FeatureImportanceProps> = ({ featureImportance }) => {
  const formatFeatureData = (featureData: any) => {
    if (!featureData?.topFeatures) return [];
    
    return featureData.topFeatures.map((feature: any) => ({
      name: feature.name,
      value: parseFloat((feature.correlation * 100).toFixed(1)),
      samples: feature.samplesCount
    }));
  };

  const formattedData = formatFeatureData(featureImportance);

  return (
    <Card className="col-span-1">
      <CardHeader>
        <CardTitle>Feature Importance</CardTitle>
      </CardHeader>
      <CardContent className="h-[300px]">
        {featureImportance?.topFeatures ? (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={formattedData}
              layout="vertical"
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" domain={[-100, 100]} />
              <YAxis 
                type="category" 
                dataKey="name" 
                width={150}
                tickFormatter={(value) => {
                  return value.length > 15 ? value.substring(0, 15) + '...' : value;
                }}
              />
              <Tooltip 
                formatter={(value, name, props) => {
                  return [`${value}% correlation (${props.payload.samples} samples)`, 'Importance'];
                }}
                labelFormatter={(value) => `Feature: ${value}`}
              />
              <Bar dataKey="value" fill="#4ade80" barSize={20}>
                {formattedData.map((entry: any, index: number) => (
                  <Cell 
                    key={`cell-${index}`} 
                    fill={entry.value >= 0 ? "#4ade80" : "#f87171"} 
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className="flex items-center justify-center h-full">
            <p className="text-muted-foreground">
              {featureImportance?.error || "Not enough data for feature importance analysis"}
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
